<mat-toolbar>
    <mat-toolbar-row>
      <button (click)="toggleSideBar()" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
      
      <!-- <span><img src="../../../assets/img/Logo - maknetic.png"/></span> -->
  
      <div fxFlex fxLayout="row" fxLayoutAlign="end center">
        <!-- <ul fxLayout="row" fxLayoutGap="20px">
          <button mat-icon-button [matMenuTriggerFor]="langMenu">
            <img id="idioma" src="../../../assets/img/flags/{{selectedLanguageFlag}}.svg">
        </button>
        <mat-menu #langMenu="matMenu" fxLayoutAlign="left center">
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('es')" mat-menu-item ><img id="idioma" src="../../../assets/img/flags/es.svg"> {{'langs.es' | translate}}</button>
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('cat')" mat-menu-item ><img id="idioma" src="../../../assets/img/flags/cat.svg"> {{'langs.cat' | translate}}</button>
          <button mat-menu-item fxLayoutAlign="left center"  id="idioma" (click)="changeLang('en')" mat-menu-item ><img id="idioma" src="../../../assets/img/flags/en.svg"> {{'langs.en' | translate}}</button>
        </mat-menu>
          <li>
            <button mat-button (click)="logout()">
              <mat-icon>logout</mat-icon>
              <label class="logOutText">{{ 'inputs.sign_out' | translate }}</label>
            </button>
          </li>
        </ul> -->
        <ul fxLayout="row" fxLayoutGap="5px">
  
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('es')" mat-menu-item ><img id="idioma" src="../../../assets/img/flags/es_black.png"></button>
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('cat')" mat-menu-item ><img id="idioma" src="../../../assets/img/flags/cat_black.png"></button>
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('en')" mat-menu-item ><img id="idioma" src="../../../assets/img/flags/en_black.png"></button>
  
  
        </ul>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  